import { useRouter } from 'next/router';

import { OFFERS_ROUTER, VENDORS_ROUTER } from '~/constants/router';
import { openPageModal } from '~/utils/mobileApp';

import type { OAISchema } from '~/types/openapi';

type Props = OAISchema['MarketProductDetailsResponseV2'];
type ContentImage = NonNullable<Props['contentImages']>[number];

function ProductSubImages({
  contentImages = [],
}: Pick<Props, 'offerId' | 'status' | 'productCode' | 'contentImages'>) {
  const router = useRouter();

  const handleImageClick = (image: ContentImage) => {
    switch (image.linkType) {
      case 'INTERNAL_PRODUCT':
        // 같은 창에서 연결 상품 상세로 이동 (뒤로가기 복귀)
        if (image.linkOfferVendorId && image.linkOfferId) {
          void router.push(VENDORS_ROUTER.productDetail(image.linkOfferVendorId, image.linkOfferId));
        }
        break;
      case 'INTERNAL_SHOWCASE':
        if (image.linkShowcaseCode) {
          void router.push(OFFERS_ROUTER.showcase(image.linkShowcaseCode));
        }
        break;
      case 'EXTERNAL': {
        if (!image.linkUrl) break;
        // 앱: web2app.openModal(현재 창 위 새 웹뷰) / 웹: 새 탭 fallback
        const externalUrl = image.linkUrl;
        openPageModal(externalUrl, () => window.open(externalUrl, '_blank', 'noopener,noreferrer'));
        break;
      }
      default:
        break;
    }
  };

  return (
    <div className="mb-16">
      {contentImages.map((image, index) => {
        const key = `product-detail-img-${index}`;
        const isClickable = image.linkType !== 'NONE';
        // 어떤 비율의 이미지가 올지 조차 알 수 없기 때문에 일반 img 태그 사용
        if (!isClickable) {
          return <img key={key} src={image.url} alt={key} />;
        }
        // 링크가 걸린 이미지는 키보드 접근성을 위해 button 으로 감싼다
        return (
          <button key={key} type="button" className="block w-full" onClick={() => handleImageClick(image)}>
            <img src={image.url} alt={key} />
          </button>
        );
      })}
    </div>
  );
}
export default ProductSubImages;
